import React, { FormEvent, useRef, useState } from "react";

import { useQuery } from "react-query";
import { getSchedules } from "Requests/CollectRangeCep";
import { sanitizeInput } from "Utils/Sanitize";
import { UnMaskCep } from "Utils/Masks";
import { Schedule } from "./interface";

export const useValidationCepRange = () => {
  const [error, setError] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [enableReq, setEnableReq] = useState(false);

  const refCode = useRef("");

  const {
    data: scheduleData,
    isLoading: loadingSchedule,
    isSuccess: schedulSuccess,
    error: errorSchedule,
  } = useQuery<Schedule[], { message: string }>(
    ["schedule", refCode.current],
    () => getSchedules(zipcode.replace("-", "")),
    {
      refetchOnWindowFocus: false,
      enabled: enableReq,
      retry: 1,
    }
  );

  const isError = !!error;

  const onSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event?.preventDefault();

    try {
      if (zipcode?.length < 9) throw new Error("Informe um CEP válido");

      setError("");
      const zip_code = UnMaskCep(zipcode);
      refCode.current = zip_code;
      setEnableReq(true);
    } catch (error: any) {
      setError(error?.message);
    }
  };

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    if (enableReq) setEnableReq(false);
    const sanitized = sanitizeInput(e.target.value) as string;

    setZipcode(sanitized);
  }

  function handleClear() {
    setZipcode("");
    setError("");

    const input = document.querySelector("#cep") as HTMLInputElement;

    if (input) return input.focus();

    return null;
  }

  return {
    onSubmit,
    handleChange,
    zipcode,
    error,
    handleClear,
    loadingSchedule,
    scheduleData,
    schedulSuccess,
    isError,
    errorSchedule,
  };
};
